<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" :modal="false">
        <div class="carBox">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>角色名称：</label>
                        <el-input v-model="search_Obj.f_rolename" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup">
                        <label>角色类型：</label>
                        <el-select v-model="search_Obj.f_role_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('role_type')" :key="'role_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>技术服务人员：</label>
                        <el-select v-model="search_Obj.f_is_jishu" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('yesNo')" :key="'yesNo'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <el-button type="primary"  @click="selRoles">添加选中</el-button>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="rolename" label="角色名称" sortable="custom"></el-table-column>
                        <el-table-column prop="role_type" label="角色类型" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.role_type, "role_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="is_jishu" label="技术服务人员" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.is_jishu, "yesNo") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" plain type="primary" @click="selThis(scope.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil";

export default {
    name: "roleList",
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        org_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.org_id = this.org_id;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '分配角色',
            menu_id: 1220,
            list_url: "/api/admin/role/list1",
            search_Obj: {
                f_rolename: '',
                f_role_type: '',
                f_is_jishu: '',
                org_id: '',
            },
            del_Obj:{
                url:'/api/admin/role/del',
                data:{
                    ids:''
                }
            },
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            enu_name: ['role_type', 'yesNo'],
            showflag: false,
        };
    },
    mounted() {},
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        selThis(obj){
            this.$emit("selectRole", obj.id)
        },
        selRoles(){
            if (this.selectData.length <= 0) {
                this.$msg("请选择要添加的角色")
            } else {
                let ids = '';
                for (let data of this.selectData) {
                    if (ids === '') {
                        ids = data.id + "";
                    } else {
                        ids += "," + data.id;
                    }
                }
                this.$emit("selectRole", ids)
            }
        }
    }
};
</script>